import {
  Avatar,
  Grid,
  makeStyles,
  Typography,
  Box,
  CircularProgress,
} from "@material-ui/core";
import { useTranslate } from "react-admin";
import moment from "moment";
import { useDataProvider } from "ra-core";

import Phone from "../components/Phone";
import TierMedal from "../components/TierMedal";
import Badge from "../components/Badge";
import PointIcon from "../assets/icons/point.png";
import AvatarforMemberPanel from "./AvatarforMemberPanel";
import durationFormatDate from "../utils/durationFormatDate";
import { useEffect } from "react";
import { useState } from "react";
const useStyles = makeStyles((theme) => ({
  allContainer: {
    backgroundColor: theme.pureWhite,
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  loadingContainer: {
    width: "100%",
    height: "100%",
    display: "grid",
    placeItems: "center",
  },
  fullName: {
    marginTop: 15,
    color: theme.darkGray,
    fontSize: 24,
    fontWeight: 700,
    maxWidth: "100%",
  },
  phone: {
    color: theme.darkGray,
    fontSize: 14,
    fontWeight: 600,
  },
  pointBox: {
    backgroundColor: theme.lightOrange,
    width: 307,
    height: 84,
    borderRadius: 12,
    marginTop: 5,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  pointBox_pointText: {
    color: theme.orange,
    fontSize: 10,
    lineHeight: 1,
  },
  pointBox_subBox: {
    display: "flex",
    flexDirection: "column",
    marginLeft: 8,
  },
  pointBox_Icon: {
    width: 50,
    height: 50,
  },
  grayBox: {
    backgroundColor: "#f4f4f4",
    width: 307,
    height: 67,
    borderRadius: 12,
    marginTop: 12,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
  },
  ltv_text: {
    fontSize: 16,
    lineHeight: "18px",
    fontWeight: "normal",
  },
  ltv_value: {
    fontSize: 30,
    fontWeight: 700,
    lineHeight: "36px",
  },
  lifetime_valueBox: {
    backgroundColor: "#f4f4f4",
    width: 307,
    height: 73,
    borderRadius: 12,
    marginTop: 12,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
  },
  grayBox_subBox: { flexGrow: 1 },
  grayBox_Text: { fontSize: 10 },
  grayBox_Number: { fontSize: 20 },
  bottomContainer: {
    marginTop: 12,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: 327,
  },
  badgeIcon: {
    maxWidth: 36,
    maxHeight: 36,
  },
  badgeContainer: {
    display: "flex",
    flexDirection: "row",

    marginTop: 0,
  },
  avatarContainer: {
    width: 142,
    height: 155,
    marginTop: 30,
    position: "relative",
  },
  bottomCircle: {
    display: "grid",
    gridTemplateRows: "50% 50%",
    justifyContent: "center",
    alignContent: "center",
    width: 90,
    height: 90,
    fontSize: 14,
    backgroundColor: theme.lightGray2,
  },
  bottomCircle_title: {
    width: "80px",
    fontSize: 12,
    lineHeight: 1,
    wordWrap: "break-word",
    fontWeight: "bolder",
  },
  bottomCircle_value: {
    fontSize: 14,
  },
  bottomCircle_caption: {
    fontSize: 12,
    paddingTop: "5px",
  },
}));

const MemberInfoPanel = ({ id }) => {
  const classes = useStyles();
  const [member, setMember] = useState();
  const [loading, setLoading] = useState(true);
  const [error] = useState(false);
  const dataProvider = useDataProvider();
  useEffect(() => {
    async function loadMember(id) {
      const result = await dataProvider.getOne("members", { id: id });
      setMember(result.data);
      setLoading(false);
    }
    setLoading(true);
    loadMember(id);
  }, [id, dataProvider]);

  const translate = useTranslate();
  if (loading)
    return (
      <Box className={classes.loadingContainer}>
        <CircularProgress color="primary" />
      </Box>
    );
  if (error) return <Typography>Error</Typography>;
  const tier = member.tier?.current;
  const ltv = member.lifetime_value?.total_revenue;
  const totalTransaction = member.lifetime_value.total_transaction;
  const point = member.lifetime_value.remaining_reward;
  const totalQTY = member.lifetime_value.total_qty;
  const profileImage = member.image_url;
  const duration = member.lifetime_value.duration;
  const frequent = member.lifetime_value.top_frequent_category?.name;
  const frequent_value = member.lifetime_value.top_frequent_category?.frequent;
  const expense = member.lifetime_value.top_expense_category?.name;
  const expense_value = member.lifetime_value.top_expense_category?.price;
  const latest = member.lifetime_value.last_expense_category?.name;
  const latest_value = member.last_transaction_time;
  const badges = member.badges;
  const version = member.__v;
  const firstname = member.firstname;
  const lastname = member.lastname;
  const phone = member.phone;

  return (
    <div className={classes.allContainer}>
      <Box className={classes.avatarContainer}>
        <AvatarforMemberPanel
          alt={firstname ?? lastname}
          src={profileImage}
          memberId={id}
          version={version}
        />

        <TierMedal
          image={tier.image_url}
          name={tier.name}
          style={{
            position: "absolute",
            bottom: -20,
            left: "50%",
            transform: "translate(-50%, 0%)",
          }}
        />
      </Box>
      <Typography className={classes.fullName} noWrap>
        {firstname} {lastname}
      </Typography>
      <Phone number={phone} />
      {badges && (
        <Box className={classes.badgeContainer}>
          {
            badges
              .filter((v, i, a) => a.findIndex((t) => t.name === v.name) === i)
              .map((badge) => (
                <Badge data={badge} />
              )) //Find Only Unique badge for now
          }
        </Box>
      )}
      <Box className={classes.pointBox}>
        <Avatar
          alt={"P"}
          className={classes.pointBox_Icon}
          src={PointIcon}
        ></Avatar>
        <Box className={classes.pointBox_subBox}>
          <Typography className={classes.pointBox_pointText}>
            {translate("ra.text.points")}
          </Typography>
          <Typography variant="h5">
            {point ? Number(point).toLocaleString() : 0}
          </Typography>
        </Box>
      </Box>
      <Box className={classes.lifetime_valueBox}>
        <Box className={classes.grayBox_subBox}>
          <Typography
            className={classes.ltv_text}
            align="center"
            variant="subtitle2"
          >
            {translate("ra.text.profileBar.lifeTimeValueTHB")}
          </Typography>
          <Typography className={classes.ltv_value} align="center">
            {ltv ? Number(ltv).toLocaleString() : 0}
          </Typography>
        </Box>
      </Box>
      <Box className={classes.grayBox}>
        <Box className={classes.grayBox_subBox}>
          <Typography className={classes.grayBox_Number} align="center">
            {totalTransaction}
          </Typography>
          <Typography className={classes.grayBox_Text} align="center">
            {translate("ra.text.profileBar.transactions")}
          </Typography>
        </Box>
        <Box className={classes.grayBox_subBox}>
          <Typography className={classes.grayBox_Number} align="center">
            {totalQTY}
          </Typography>
          <Typography className={classes.grayBox_Text} align="center">
            {translate("ra.text.profileBar.quantities")}
          </Typography>
        </Box>
        <Box className={classes.grayBox_subBox}>
          <Typography className={classes.grayBox_Number} align="center">
            {durationFormatDate(duration)}
          </Typography>
          <Typography className={classes.grayBox_Text} align="center">
            {durationFormatDate(duration, translate)}
          </Typography>
        </Box>
      </Box>
      <Box>
        <Grid container className={classes.bottomContainer}>
          <Grid item xs={4} style={{ display: "grid", placeContent: "center" }}>
            <Avatar variant="rounded" className={classes.bottomCircle}>
              <Typography className={classes.bottomCircle_title} align="center">
                {latest}
              </Typography>
              <Typography className={classes.bottomCircle_value} align="center">
                {totalTransaction > 0
                  ? moment(latest_value).format("D MMM YY")
                  : "-"}
              </Typography>
            </Avatar>
            <Typography className={classes.bottomCircle_caption} align="center">
              {translate("ra.text.profileBar.latest")}
            </Typography>
          </Grid>
          <Grid item xs={4} style={{ display: "grid", placeContent: "center" }}>
            <Avatar variant="rounded" className={classes.bottomCircle}>
              <Typography className={classes.bottomCircle_title} align="center">
                {frequent}
              </Typography>
              <Typography className={classes.bottomCircle_value} align="center">
                {getLocaleString(frequent_value)}
              </Typography>
            </Avatar>
            <Typography className={classes.bottomCircle_caption} align="center">
              {translate("ra.text.profileBar.frequence")}
            </Typography>
          </Grid>
          <Grid item xs={4} style={{ display: "grid", placeContent: "center" }}>
            <Avatar variant="rounded" className={classes.bottomCircle}>
              <Typography className={classes.bottomCircle_title} align="center">
                {expense}
              </Typography>
              <Typography className={classes.bottomCircle_value} align="center">
                {getLocaleString(expense_value)}
              </Typography>
            </Avatar>
            <Typography className={classes.bottomCircle_caption} align="center">
              {translate("ra.text.profileBar.expensive")}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

const getLocaleString = (value) => {
  return Number(value) ? Number(value).toLocaleString() : "-";
};

export default MemberInfoPanel;
